import {
  OnInit,
  Component,
  ElementRef,
  NgZone,
  DoCheck,
  OnDestroy,
  ChangeDetectionStrategy,
  HostListener,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fromEvent, ReplaySubject, takeUntil } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';

import {
  ModalSimpleSocialComponent,
  ModalSimpleSocialData,
} from '../modal-simple-social/modal-simple-social.component';
import { SceneService } from '../services/scene.service';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-social-pixi-canvas',
  template: ``,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SocialPixiCanvasComponent extends Loggable implements OnInit, OnDestroy, DoCheck {
  private wrapperElementWidth = 0;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private elementRef: ElementRef,
    private ngZone: NgZone,
    public dialog: MatDialog,
    private sceneService: SceneService,
    private themeService: ThemeService,
  ) {
    super();
    this.setDisplayName('SocialPixiCanvasComponent');
  }

  @HostListener('pointerover') private onPointerOver() {
    this.sceneService.sceneManager?.showCustomCursor();
  }
  // @HostListener('pointermove', ['$event']) private onPointerMove($event: PointerEvent) {
  //   this.sceneService.sceneManager?.handlePointerMove($event);
  // }

  private init(): void {
    this.ngZone.runOutsideAngular(() => {
      this.sceneService.init(this.elementRef);
    });
    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.sceneService.resizeCanvas();
      });
  }

  public ngOnInit(): void {
    try {
      this.init();
      this.themeService.init();
    } catch (err) {
      this.error('init error', err);
      this.showWebGLError();
    }
  }

  public ngDoCheck(): void {
    if (this.elementRef.nativeElement.offsetWidth !== this.wrapperElementWidth) {
      if (this.wrapperElementWidth > 0 && this.sceneService.sceneManager) {
        this.sceneService.resizeCanvas();
      }
      this.wrapperElementWidth = this.elementRef.nativeElement.offsetWidth;
    }
  }

  private showWebGLError(): void {
    const data = {
      modalTitle: 'Web GL Not Supported',
      text: 'Looks like your browser doesn\'t support Web GL. If using Chrome ensure you have the latest version and have "Use hardware acceleration enabled when available" under Advanced Settings.',
      primaryButtonText: 'Okay',
    };

    this.dialog.open<ModalSimpleSocialComponent, ModalSimpleSocialData>(ModalSimpleSocialComponent, {
      panelClass: 'social-modal',
      data: data,
    });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
